import React, { useEffect, forwardRef, useState, useCallback, useMemo } from 'react';
import { CircularProgress, Grid, Select, MenuItem, Button, TextField, Typography, InputLabel } from '@material-ui/core';
import MaterialTable from 'material-table';
import { useHistory } from 'react-router';
import { safeGet } from '../../../axios-default';
import QueryString from 'querystring';
import axios from '../../../axios-default';
import { connect, useDispatch, useSelector } from 'react-redux';
import { easySnackbar } from '../../../store/Noti/noti.actions';
import { updateRes } from '../../../store/res/res.action';
import { Edit as EditIcon, Undo as UndoIcon, Delete as DeleteIcon, Add as AddIcon } from '@material-ui/icons';
import {
    Close as CloseIcon,
    Check as CheckIcon,
    AddBox,
    ArrowDownward,
    Check,
    ChevronLeft,
    ChevronRight,
    Clear,
    DeleteOutline,
    Edit,
    FilterList,
    FirstPage,
    LastPage,
    Remove,
    SaveAlt,
    Search,
    ViewColumn,
    StarRate,
} from '@material-ui/icons';
import Modal from '../../../components/Modal/modal';
import { makeStyles } from '@material-ui/core/styles';

const TableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const useStyles = makeStyles((theme) => ({
    '@global': {
        body: {
            background: '#fdfdfd',
        },
    },
    textArea: {
        width: '100%',
    },
    root: {
        flexGrow: 1,
    },
    rootContainer: {
        padding: 16,
        margin: '8px 0px 0px 238px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '12px 0px 0px 0px',
            width: '100%',
        },
        width: 'calc(100% - 238px)',
    },
    scanBox: {
        padding: 16,
        margin: '8px 0px',
    },
    textField: {
        // marginLeft: "8px",
        // marginRight: "8px",
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'grey',
            },
            '&:hover fieldset': {
                borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'black',
            },
        },
    },
    dateField: {
        width: '100%',
    },
    formControl: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
        marginLeft: 0,
    },
    submitBtn: {
        backgroundColor: '#061a2e !important',
        color: 'white',
        padding: '8px 24px',
        margin: '12px 0px',
    },
    linkBtn: {
        background: 'rgba(89,54,135,1)',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        margin: '16px 0px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: '4px 72px',
            width: 'unset',
        },
        '&:hover': {
            background: 'rgb(77, 74, 142)',
            color: 'white',
        },
    },
}));

export const NewCaseOption = ({}) => {
    const classes = useStyles();
    const Actions = [
        (row) => ({
            icon: () => <EditIcon />,
            tooltip: 'Edit',
            onClick: (_, data) => {
                setUpdatedResource({
                    ...updatedResource,
                    srData: data,
                });

                setEditModalOpen(true);
            },
        }),
        ,
        (row) => ({
            icon: () => <DeleteIcon />,
            onClick: async (_, oldData) => {
                try {
                    if (window.confirm('Confirm to delete this record?')) {
                        let { data } = await axios.post(`case/delete_newcase_option`, oldData);
                        if (!data.success) {
                            dispatch(easySnackbar('Error. Please check your input.', 'error'));
                            return;
                        }
                        dispatch(easySnackbar('Deleted.', 'success'));
                        reloadPage();
                    }
                } catch (err) {
                    dispatch(easySnackbar('Error. Please check your input.', 'error'));
                }
            },
        }),
        /*
     ,row=>({
     icon: () => (row.cancel_flag ?<UndoIcon/>:<DeleteIcon/>),
          onClick: async (_, oldData) => {
            try {
                if (window.confirm('Are you going to delete this category?')) {
                  let {data} = await axios.post(
                    `accessories/distrorderCategorydelete`,
                    oldData
                  )
                  if (!data.success){
                    dispatch(easySnackbar('Error. Please check your input.', 'error'))
                    return
                  }
                  dispatch(easySnackbar('Deleted.', 'success'))
                  reloadPage()
                }
              } catch (err) {
                dispatch(easySnackbar('This record contains Sub Category items, please check!', 'error'))
              }
            }
   })
   */
    ];
    const history = useHistory();
    const dispatch = useDispatch();
    const res = useSelector(({ res }) => res);
    const [data, setData] = useState([]),
        [loading, setLoading] = useState(true),
        [errors, setErrors] = useState({}),
        [search, setSearch] = useState(''),
        [modalOpen, setModalOpen] = useState(false),
        [opt1, setOpt1] = useState(''),
        [opt2, setOpt2] = useState(''),
        [description, setDescription] = useState(''),
        [editModalOpen, setEditModalOpen] = useState(false),
        [updatedResource, setUpdatedResource] = useState({ srData: Object.assign({}) });

    const reloadPage = () => {
        const curPage = window.location.pathname;
        history.push('/blank');
        history.replace(curPage);
    };

    const handleSubmit = useCallback(async (editing) => {
        try {
            let errors = {};
            if (editing) {
            } else {
                if (updatedResource.srData.distr_group_id.length == 0) {
                    errors['distr_group_id'] = 'Distr Group is required';
                }
            }
            if (updatedResource.srData.opt1.length == 0) {
                errors['opt1'] = 'Option 1 is required';
            }
            if (updatedResource.srData.opt2.length == 0) {
                errors['opt2'] = 'Option 2 is required';
            }
            if (updatedResource.srData.description.length == 0) {
                errors['description'] = 'Description is required';
            }

            if (Object.keys(errors).length > 0 && errors.constructor === Object) {
                setErrors({ errors: errors });
                dispatch(easySnackbar('Error. Please check your input.', 'error'));
                return;
            }
            console.log('editing' + editing);
            let { data } = await axios.post(
                `case/save_newcase_option`,

                { ...updatedResource.srData, editing }
            );
            if (!data.success) {
                dispatch(easySnackbar('Error. Please check your input.', 'error'));
                return;
            }

            dispatch(easySnackbar('Success', 'success'));
            setUpdatedResource({ srData: Object.assign({}) });
            reloadPage();
            setLoading(true);
            setModalOpen(false);
            reloadPage();
        } catch (err) {
            dispatch(easySnackbar('Error. Please check your input.', 'error'));
            console.error(err.response);
        } finally {
            setLoading(false);
        }
    });
    const countrySelect = useMemo(
        () =>
            Object.entries(res.distr_groups).map(([id, c]) => (
                <MenuItem value={c.distr_group_id} key={c.distr_group_id}>
                    {c.distr_group_name}
                </MenuItem>
            )),
        [res?.distr_groups]
    );

    useEffect(() => {
        if (JSON.parse(localStorage.getItem('distr_group_id')) === 'null') {
        } else {
            var distr_group_id = JSON.parse(localStorage.getItem('distr_group_id'));
            setUpdatedResource(
                {
                    ...updatedResource,
                    srData: {
                        ...updatedResource.srData,
                        ['distr_group_id']: JSON.parse(localStorage.getItem('distr_group_id')),
                    },
                },
                () => {}
            );
        }
    }, []);

    const dataGetter = useCallback(
        async (query) => {
            await dispatch(updateRes('distr_group'));
            var distr_group_id = JSON.parse(localStorage.getItem('distr_group_id'));
            const { pageSize, page: pageNo, search, orderBy, orderDirection } = query;
            try {
                const { case_options: data, total } = await safeGet(
                    `case/newcase_option_list?${QueryString.encode({
                        //all: 1,
                        pageNo,
                        pageSize,
                        search,
                        sortBy: orderBy?.field,
                        sortDir: orderDirection,
                        distr_group_id: distr_group_id === 'null' ? '' : distr_group_id,
                    })}`
                );

                if (loading) setLoading(false);

                return {
                    data: data,
                    page: pageNo ?? 0,
                    totalCount: total ?? 0,
                };
            } catch (err) {
                console.error(err);
            }
        },
        [search]
    );

    const handleopt1Change = (event) => {
        const value = event.target.value.slice(0, 20);
        setOpt1(value);

        setUpdatedResource({
            ...updatedResource,
            srData: {
                ...updatedResource.srData,
                ['opt1']: value ?? null,
            },
        });
    };

    const handleopt2Change = (event) => {
        const value = event.target.value.slice(0, 20);
        setOpt2(value);
        setUpdatedResource({
            ...updatedResource,
            srData: {
                ...updatedResource.srData,
                ['opt2']: value ?? null,
            },
        });
    };

    const handledescriptionChange = (event) => {
        const value = event.target.value.slice(0, 4000);
        setDescription(value);
        setUpdatedResource({
            ...updatedResource,
            srData: {
                ...updatedResource.srData,
                ['description']: value ?? null,
            },
        });
    };

    const handleUpdate = useCallback(
        (field) =>
            ({ target: { value } }) => {
                setUpdatedResource({
                    ...updatedResource,
                    srData: {
                        ...updatedResource.srData,
                        [field]: value ?? null,
                    },
                });
            },
        [updatedResource, setUpdatedResource]
    );
    return (
        <div>
            <Button className={classes.linkBtn} onClick={() => setModalOpen(true)}>
                Add New Case Option
            </Button>
            <MaterialTable
                title="New Case Option Setup"
                data={dataGetter}
                actions={
                    ['SADMIN', 'ADMIN', 'DISTR'].includes(
                        localStorage.getItem('role') && JSON.parse(localStorage.getItem('role'))
                    ) && Actions
                }
                columns={[
                    {
                        field: 'distr_group_name',
                        title: 'Distributor Group Name',
                        sorting: true,
                        filtering: true,
                        defaultSort: 'asc',
                    },
                    {
                        field: 'opt1',
                        title: 'Option 1 Name',
                        sorting: true,
                        filtering: true,
                    },
                    {
                        field: 'opt2',
                        title: 'Option 2 Name',
                        sorting: true,
                        filtering: true,
                    },
                    {
                        field: 'description',
                        title: 'Description',
                        sorting: true,
                        filtering: true,
                    },
                ]}
                /*onRowClick={(_, data) => {
       history.push(`/admin/orderItemFormMain/${data.acc_id}`)
     }}*/
                options={{
                    initialPage: 0,
                    emptyRowsWhenPaging: false,

                    debounceInterval: 700,
                    columnsButton: true,

                    pageSize: 10,

                    search: false,
                    pageSizeOptions: [10, 15, 30, 50, 100],
                    minBodyHeight: 700,
                }}
                icons={TableIcons}
                isLoading={loading}
            />
            <Modal
                className="modal"
                modal=""
                title="Edit New Case Option"
                open={editModalOpen}
                handleClose={() => {
                    setEditModalOpen(false);
                    setUpdatedResource({ srData: Object.assign({}) });
                }}
                handleDataSave={() => handleSubmit(true)}
                //modalError={this.modalError}
                submitButton={true}
            >
                <TextField
                    label="Option 1"
                    value={updatedResource.srData.opt1}
                    onChange={handleopt1Change}
                    inputProps={{ maxLength: 20 }}
                    required
                />
                <br />
                <TextField
                    label="Option 2"
                    value={updatedResource.srData.opt2}
                    onChange={handleopt2Change}
                    inputProps={{ maxLength: 20 }}
                    required
                />
                <br />
                <Typography variant="h6">Description</Typography>
                <TextField
                    label=""
                    className={classes.textArea}
                    multiline
                    rows={4}
                    value={updatedResource.srData.description}
                    onChange={handledescriptionChange}
                    inputProps={{ maxLength: 4000 }}
                    required
                />
            </Modal>
            <Modal
                className="modal"
                modal=""
                title="Add New Case Option"
                open={modalOpen}
                handleClose={() => {
                    setModalOpen(false);
                    setUpdatedResource({ srData: Object.assign({}) });
                }}
                handleDataSave={() => handleSubmit(false)}
                //modalError={this.modalError}
                submitButton={true}
            >
                <InputLabel>Select Distr</InputLabel>
                <Select
                    displayEmpty
                    onChange={handleUpdate('distr_group_id')}
                    style={{ width: '100%' }}
                    value={
                        JSON.parse(localStorage.getItem('distr_group_id')) === 'null'
                            ? updatedResource.srData.distr_group_id
                            : JSON.parse(localStorage.getItem('distr_group_id'))
                    }
                    disabled={JSON.parse(localStorage.getItem('distr_group_id')) !== 'null'}
                    required
                >
                    {countrySelect}
                </Select>
                <TextField
                    label="Option 1"
                    value={updatedResource.srData.opt1}
                    onChange={handleopt1Change}
                    inputProps={{ maxLength: 20 }}
                    required
                />
                <br />
                <TextField
                    label="Option 2"
                    value={updatedResource.srData.opt2}
                    onChange={handleopt2Change}
                    inputProps={{ maxLength: 20 }}
                    required
                />
                <br />
                <Typography variant="h6">Description</Typography>
                <TextField
                    label=""
                    multiline
                    className={classes.textArea}
                    rows={4}
                    value={updatedResource.srData.description}
                    onChange={handledescriptionChange}
                    inputProps={{ maxLength: 4000 }}
                    required
                />
            </Modal>
        </div>
    );
};

export default NewCaseOption;
